import React from 'react'
import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { Breadcrumbs } from '../Breadcrumbs'
import { BreadcrumbsProps } from '../types'

export const mount: MountWithRootOptions<BreadcrumbsProps> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<Breadcrumbs {...renderProps} />, rootElement, rootOptions)
}
